import { makeStyles, styled } from '@material-ui/core/styles'

export const CoachName = styled('div')(({ theme, coach }) => ({
  marginLeft: coach.profilePhoto ? 0 : '130px',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'left',
  justifyContent: 'center',
  paddingRight: 0,
  paddingLeft: theme.spacing(4),
  [theme.breakpoints.down('md')]: {
    marginLeft: coach.profilePhoto ? 0 : '55px',
  },
  [theme.breakpoints.down('sm')]: {
    marginLeft: coach.profilePhoto ? 0 : '40px',
  },
  [theme.breakpoints.down('xs')]: {
    minWidth: 100,
  },
}))

export const PlayoffButton = styled('div')(({ theme, complete }) => ({
  borderRadius: '6px',
  border: complete.playoff ? 'none' : `1px solid ${theme.palette.secondary.light}`,
  color: complete.playoff ? theme.palette.primary.contrastText : theme.palette.secondary.light,
  backgroundColor: complete.playoff ? theme.palette.primary.dark : 'transparent',
  ...theme.typography.formTags,
  padding: '5px 10px 5px 10px',
  width: 'max-content',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  marginBottom: theme.spacing(2),
}))

const useStyles = makeStyles((theme) => ({
  myLeaderboard: {
    '&>div:nth-child(1)>div': {
      borderRadius: '8px 8px 0 0',
      marginBottom: 0,
    },
    '&>div:nth-child(2)': {
      borderRadius: '0 0 8px 8px',
    },
  },
  wrapper: ({ nested }) => ({
    '&>div:nth-child(2)': {
      borderRadius: nested ? '0 0 8px 8px' : '8px 8px 0 0',
      marginBottom: !nested && 0,
    },
    '&>div:nth-child(3)': {
      borderRadius: !nested && '0 0 8px 8px',
    },
  }),
  showcaseCard: {
    borderRadius: '8px',
    background: theme.palette.common.white,
    marginBottom: theme.spacing(1),
    boxShadow: theme.palette.shadow.cardBoxShadow,
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    color: theme.palette.secondary.main,
    padding: theme.spacing(10),
    [theme.breakpoints.down('xs')]: {
      paddingRight: 0,
      paddingLeft: 0,
    },
  },
  outer: {
    borderRadius: '8px',
    background: theme.palette.common.white,
    marginBottom: theme.spacing(1),
    boxShadow: theme.palette.shadow.cardBoxShadow,
    padding: theme.spacing(2),
    [theme.breakpoints.down('xs')]: {
      padding: theme.spacing(1),
    },
  },
  info: {
    display: 'flex',
    alignItems: 'center',
  },
  item: {
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    color: theme.palette.secondary.main,
    padding: theme.spacing(2),
    [theme.breakpoints.down('xs')]: {
      paddingRight: 0,
      paddingLeft: 0,
    },
  },
  coachItem: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    minHeight: '60px',
    color: theme.palette.common.black,
    [theme.breakpoints.down('xs')]: {
      paddingRight: 0,
      paddingLeft: 0,
    },
  },
  bordered: {
    border: `1px solid ${theme.palette.grey[200]}`,
    borderRadius: 4,
  },
  topRounding: ({ nested }) => ({
    borderRadius: nested ? 0 : '8px',
    marginBottom: nested && 0,
    backgroundColor: theme.palette.secondary.main,
    color: theme.palette.secondary.contrastText,
    boxShadow: theme.palette.shadow.cardBoxShadow,
    '&>div': {
      ...theme.typography.overline,
      display: 'flex',
    },
  }),
  rank: {
    display: 'flex',
    width: theme.spacing(4),
    paddingRight: theme.spacing(2),
    alignItems: 'center',
    justifyContent: 'center',
    color: theme.palette.secondary.main,
    fontSize: 14,
    fontFamily: theme.typography.fontFamily,
    fontWeight: 'bold',
    [theme.breakpoints.up('md')]: {
      width: theme.spacing(8),
    },
    [theme.breakpoints.down('xs')]: {
      paddingLeft: theme.spacing(2),
      fontSize: '13px',
    },
  },
  dataWrapper: {
    display: 'flex',
    justifyContent: 'space-between',
    flexGrow: 1,
    paddingRight: 0,
    paddingLeft: theme.spacing(2),
    minWidth: 120,
    [theme.breakpoints.down('xs')]: {
      minWidth: 100,
      paddingLeft: theme.spacing(1),
    },
  },
  itemNameWrapper: {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
  },
  itemName: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'left',
    justifyContent: 'center',
    color: theme.palette.secondary.main,
    [theme.breakpoints.down('xs')]: {
      maxWidth: '80px',
    },
  },
  itemStreamUrl: {
    display: 'flex',
    flexGrow: 1,
    flexDirection: 'column',
    alignItems: 'flex-end',
    justifyContent: 'center',
    height: theme.spacing(5),
  },
  liveStreamIcon: {
    background: 'url(/images/liveStreamIcon.svg)',
    width: 34,
    height: 24,
    '&:hover': {
      background: 'url(/images/liveStreamIconHover.svg)',
    },
  },
  clickHover: {
    cursor: 'pointer',
  },
  caption: {
    color: theme.palette.grey.dark,
    textAlign: 'center',
    marginLeft: '15px',
    [theme.breakpoints.down('sm')]: {
      marginLeft: '5px',
    },
  },
  firstName: {
    fontSize: 12,
    lineHeight: 1,
  },
  lastName: {
    color: theme.palette.secondary.main,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    textTransform: 'capitalize',
    [theme.breakpoints.only('xs')]: {
      fontSize: '14px',
    },
  },
  itemValue: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: theme.spacing(6),
    height: theme.spacing(5),
    fontWeight: 'bold',
    fontFamily: theme.typography.fontFamily,
    [theme.breakpoints.up('sm')]: {
      width: theme.spacing(6),
    },
    [theme.breakpoints.up('md')]: {
      width: theme.spacing(10),
    },
  },
  itemFlag: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '3em',
    height: '3em',
    borderRadius: '50%',
    border: `2px solid ${theme.palette.divider}`,
    overflow: 'hidden',
    boxShadow: '0px 5px 5px rgba(0,0,0,0.3)',
    [theme.breakpoints.down('md')]: {
      width: '2em',
      height: '2em',
      border: `1px solid ${theme.palette.divider}`,
      marginLeft: '2px',
      marginRight: '2px',
    },
    '&.hide': {
      opacity: 0,
    },
  },
  roundImage: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '4rem',
    height: '4rem',
    borderRadius: '50%',
    border: `2px solid ${theme.palette.divider}`,
    overflow: 'hidden',
    margin: '0 0 0 24px',
    boxShadow: '0 5px 5px rgba(0, 0, 0, 0.3)',
    [theme.breakpoints.down('md')]: {
      border: `1px solid ${theme.palette.divider}`,
    },
    [theme.breakpoints.down('xs')]: {
      marginLeft: '12px',
      width: '2.5rem',
      height: '2.5rem',
    },
  },
  coachAvatar: {
    height: '4rem',
    width: '4rem',
    [theme.breakpoints.down('xs')]: {
      height: '2.5rem',
      width: '2.5rem',
    },
  },
  itemScore: {
    [theme.breakpoints.only('xs')]: {
      borderRight: 'none !important',
    },
  },
  closeButton: {
    position: 'absolute',
    top: 0,
    zIndex: 1,
    right: 0,
    [theme.breakpoints.up('md')]: {
      right: theme.spacing(3),
    },
  },
  labelRank: {
    textTransform: 'uppercase',
    color: theme.palette.secondary.contrastText,
    fontSize: '14px',
    paddingRight: 0,
    paddingLeft: 0,
    [theme.breakpoints.only('sm')]: {
      fontSize: '11px',
    },
  },
  labelValue: {
    display: 'flex',
    width: theme.spacing(6),
    height: theme.spacing(5),
    alignItems: 'center',
    justifyContent: 'center',
    color: theme.palette.secondary.contrastText,
    fontFamily: theme.typography.fontFamily,
    fontWeight: 'bold',
    textTransform: 'uppercase',
    letterSpacing: 1.5,
    fontSize: '14px',
    [theme.breakpoints.up('sm')]: {
      width: theme.spacing(6),
    },
    [theme.breakpoints.up('md')]: {
      width: theme.spacing(10),
    },
    [theme.breakpoints.only('sm')]: {
      fontSize: '11px',
    },
  },
  hideMobile: {
    [theme.breakpoints.down('xs')]: {
      display: 'none !important',
    },
  },
  teeTime: {
    textAlign: 'center',
    lineHeight: 1,
    '& div': {
      paddingTop: 10,
    },
    '& span': {
      display: 'block',
      textTransform: 'uppercase',
      fontSize: 10,
      color: theme.palette.grey.dark,
    },
  },
  descriptionTitle: {
    marginBottom: theme.spacing(2),
    textTransform: 'capitalize',
    fontSize: '1.125rem',
    color: theme.palette.text.primary,
    fontWeight: 700,
  },
  fullLeaderBoardContainer: {
    marginTop: theme.spacing(13),
  },
  nativeDescription: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'left',
    justifyContent: 'center',
    paddingRight: 0,
    paddingLeft: theme.spacing(2),
    [theme.breakpoints.down('sm')]: {
      maxWidth: theme.spacing(30),
    },
  },
  actionButton: {
    padding: '6px 24px',
    fontSize: 'min(14px, calc(1vw + 2px))',
    lineHeight: 1,
    borderRadius: '20px',
    textAlign: 'center',
    marginRight: '24px',
    [theme.breakpoints.down('md')]: {
      margin: '8px',
    },
  },
  carrotCta: {
    marginRight: '24px',
    [theme.breakpoints.only('xs')]: {
      margin: '8px',
    },
  },
  team20triangle: {
    position: 'absolute',
    bottom: 0,
    right: 0,
    backgroundColor: (props) => (props.team20Data && props.team20Data.backgroundColor) || '#EEEEEE',
    width: '250px',
    height: '100px',
    transform: 'rotate(-22deg) translate(50px, 110px)',

    [theme.breakpoints.up('sm')]: {
      transform: 'rotate(-22deg) translate(50px, 98px)',
    },

    [theme.breakpoints.up('md')]: {
      transform: 'rotate(-22deg) translate(50px, 86px)',
    },
  },
  team20logo: {
    position: 'absolute',
    right: 0,
    bottom: 0,
    paddingRight: '4px',
    paddingBottom: '5px',
    '& img': {
      display: 'block',
      width: (props) => (props.team20Data && props.team20Data.logoWidthXs) || '36px',
    },

    [theme.breakpoints.up('sm')]: {
      paddingRight: '6px',
      paddingBottom: '6px',
      '& img': {
        width: (props) => (props.team20Data && props.team20Data.logoWidthSm) || '45px',
      },
    },
    [theme.breakpoints.up('md')]: {
      paddingRight: '7px',
      paddingBottom: '8px',
      '& img': {
        width: (props) => (props.team20Data && props.team20Data.logoWidth) || '54px',
      },
    },
  },
  disclaimer: {
    fontFamily: theme.typography.fontFamily,
    fontWeight: 'bold',
    color: '#9E9E9E',
    marginBottom: theme.spacing(2),
  },
  headlineContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-end',
    color: theme.palette.secondary.light,
    [theme.breakpoints.down('xs')]: {
      flexDirection: 'column',
      alignItems: 'flex-start',
      gap: '1rem',
    },
  },
  leaderboardButton: {
    whiteSpace: 'nowrap',
    [theme.breakpoints.down('xs')]: {
      width: '100%',
    },
    [theme.breakpoints.only('sm')]: {
      fontSize: '0.75rem',
    },
  },
  liveLine: {
    display: 'flex',
    alignItems: 'center',
  },
  formInputs: {
    marginLeft: '0.5625rem',
    whiteSpace: 'nowrap',
    lineHeight: '16px',
    ...theme.typography.formInputs,
  },
  content: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  headlineWrapper: {
    [theme.breakpoints.up('sm')]: {
      paddingRight: theme.spacing(2),
    },
  },
  headline: {
    marginBottom: theme.spacing(1),
  },
  wscStoriesWidgetContainer: {
    paddingTop: theme.spacing(3),
  },
  scorecard: {
    backgroundColor: theme.palette.blue.light25,
    borderRadius: '0 0 8px 8px',
    paddingTop: theme.spacing(2),
  },
  chevron: {
    color: theme.palette.grey.main,
    transitionProperty: 'transform',
    transitionDuration: theme.transitions.duration.shortest,
    transitionTimingFunction: theme.transitions.easing.easeInOut,
    '&.expanded': {
      transform: 'rotate(-180deg)',
    },
  },
  logoWrapper: {
    alignSelf: 'end',
    borderRadius: '2px',
    display: 'flex',
    alignItems: 'center',
    backgroundColor: (props) => (props.team20Data && props.team20Data.backgroundColor) || '#FFFFFF',
  },
  teamOf20Logo: {
    width: (props) => (props.team20Data && props.team20Data.logoWidth) || '3.5rem',
    [theme.breakpoints.down('md')]: {
      width: (props) => (props.team20Data && props.team20Data.logoWidthSm) || '45px',
    },
    [theme.breakpoints.down('xs')]: {
      width: (props) => (props.team20Data && props.team20Data.logoWidthXs) || '36px',
    },
    [theme.breakpoints.down(375)]: {
      display: 'none !important',
    },
  },
  favoriteButton: {
    [theme.breakpoints.down('xs')]: {
      padding: theme.spacing(1),
    },
  },
}))

export default useStyles
